import { useState, useEffect, useMemo } from "react";
import { map, find } from "lodash";
// import preserveRoutes from "../../constants/preserveRoutes";
// import allAcl from "../../constants/allAcl";
// eslint-disable-next-line import/no-cycle
import { useAuth } from "../useAuth";
import { callApi } from "../../api";
import { parseJSON } from "../../utility/CustomFunction";

const checkArray = (x) => (Array.isArray(x) ? x : []);

const UseAcl = (prop) => {
  const [aclData, setAclData] = useState(null);
  const { user, selectedBusiness } = useAuth();

  const fetchAllAcl = async () => {
    // const res = await callApi(
    //   `/protected/business/${selectedBusiness?.id}/userroles/all`
    // );
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(`business/:BID:/systemsettings/uzeli-user-roles-params`)}`
    );
    if (res?.success) {
      const userrolesParams  = parseJSON(res?.data[0]?.configurations);
      if(userrolesParams) setAclData(userrolesParams);
    }
    return res;
  };

  const extendAcl = (userAcl, aclParams = aclData) => {
    const newAcl = { ...userAcl };
    aclParams?.forEach((block) => {
      if (
        block.default &&
        !newAcl.blocks?.includes?.(block.id) &&
        !newAcl?.restrictions?.blocks?.includes?.(block.id)
      ) {
        newAcl.blocks = [...checkArray(newAcl?.blocks), block.id];
      }
      if (block.units) {
        block.units.forEach((unit) => {
          if (
            (unit.type === "staffList"
              ? !!(unit.default === "*" || unit.default !== "[]")
              : !!unit.default) &&
            !newAcl?.units?.[block.id]?.includes(unit.id) &&
            !newAcl?.restrictions?.units?.[block.id]?.includes(unit.id) &&
            newAcl?.blocks?.includes(block.id)
          ) {
            newAcl.units = {
              ...newAcl.units,
              [block.id]: [...checkArray(newAcl.units?.[block.id]), unit.id],
            };
          }
        });
      }
    });
    return newAcl;
  };

  const checkPermission = (acl, block, unit) => {
    if (!acl?.blocks) {
      return true;
    }
    const aclDataTemp = extendAcl(acl);
    return !!(
      aclDataTemp?.blocks?.includes(block) &&
      aclDataTemp?.units?.[block]?.includes(unit)
    );
  };

  const getAclObj = () => {
    let aclDataObj = {};
    if (user && !user.acl?.blocks) {
      const unrestrictedUnits = {};
      aclData?.forEach((bl) => {
        if (bl.units?.length) {
          unrestrictedUnits[bl?.id || ""] = bl.units?.map((x) => x.id);
        }
      });
      aclDataObj = {
        ...user.acl,
        blocks: ["unrestricted", ...(aclData || []).map((bl) => bl.id)],
        units: unrestrictedUnits,
      };
    } else {
      // const mappedRoutes = [];
      // map((user && user.acl && user.acl.blocks) || [], (block) => {
      //   const findObject = find(
      //     user.acl.units,
      //     (v, k) => String(k) === String(block)
      //   );
      //   if (findObject) {
      //     map(findObject, (route) => {
      //       mappedRoutes.push(`${route}`);
      //     });
      //   }
      //   mappedRoutes.push(`${block}`);
      // });
      aclDataObj = aclData ? extendAcl(user?.acl, aclData) : user?.acl;
    }
    const mappedRoutes = [];
    map((aclDataObj && aclDataObj.blocks) || [], (block) => {
      const findObject = find(
        aclDataObj.units,
        (v, k) => String(k) === String(block)
      );
      if (findObject) {
        map(findObject, (route) => {
          mappedRoutes.push(`${block}.${route}`);
          mappedRoutes.push(route);
        });
      }
      mappedRoutes.push(`${block}`);
    });
    if (aclDataObj?.multiLocation === true) {
      mappedRoutes.push("multiLocation");
    }
    return mappedRoutes;
  };

  const aclRules = useMemo(() => {
    if (!user) return [];
    return getAclObj();
  }, [user, aclData]);

  useEffect(() => {
    if (!prop && selectedBusiness?.id) fetchAllAcl();
  }, [!selectedBusiness?.id]);

  return {
    extendAcl,
    aclRules,
    aclData,
    getAclObj,
    checkPermission,
    fetchAllAcl,
  };
};

export default UseAcl;
